import { render } from "./License.vue?vue&type=template&id=7d884a30&scoped=true&ts=true"
import script from "./License.vue?vue&type=script&lang=ts"
export * from "./License.vue?vue&type=script&lang=ts"

import "./License.vue?vue&type=style&index=0&id=7d884a30&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d884a30"]])

export default __exports__